<div class="modal-header">
  <h5 class="modal-title"><i class="fa fa-lg fa-user-plus" aria-hidden="true"></i> Create user</h5>
  <button type="button" class="close btn" data-dismiss="modal" aria-label="Close" (click)="cancelNewUserModal()">
    <span aria-hidden="true"><i class="fa fa-times"></i></span>
  </button>
</div>

<form [formGroup]="createUserForm">
<div class="modal-body">

      <div class="form-group d-flex justify-content-between">
        <mat-form-field class="user-input">
          <input name="username" matInput required type="text" placeholder="Username" formControlName="username" minlength="4">
          <mat-error *ngIf="createUserForm.hasError('required', 'username')">
            Please enter username
          </mat-error>
          <mat-error *ngIf="createUserForm.hasError('minlength', 'username')">
            Use at least 4 characters
          </mat-error>
        </mat-form-field>

        <mat-form-field class="user-input">
          <input name="email" matInput required type="email" placeholder="Email" formControlName="email">
          <mat-error *ngIf="createUserForm.hasError('required', 'email')">
            Please enter email
          </mat-error>

          <mat-error *ngIf="createUserForm.hasError('email', 'email')">
            Please enter valid email
          </mat-error>
        </mat-form-field>
      </div>


    <div class="form-group d-flex justify-content-between">
        <mat-form-field class="user-input">
          <input name="password" matInput required type="password" placeholder="Password" formControlName="password" minlength="4">
          <mat-error *ngIf="createUserForm.hasError('required', 'password')">
            Please enter password
          </mat-error>

          <mat-error *ngIf="createUserForm.hasError('minlength', 'password')">
            Use at least 4 characters
          </mat-error>

        </mat-form-field>

        <mat-form-field class="user-input">
          <input name="passwordAgain" matInput required type="password" placeholder="Password again" formControlName="passwordAgain">
          <mat-error *ngIf="createUserForm.hasError('required', 'passwordAgain')">
            Please enter password again
          </mat-error>

          <mat-error *ngIf="createUserForm.hasError('MatchPassword', 'passwordAgain')">
            Passwords do not match
          </mat-error>
        </mat-form-field>
    </div>

      <div class="form-group">
        <mat-form-field class="user-input">
          <input name="abosId" matInput required type="number" placeholder="Abos id" formControlName="abosId">

          <mat-error *ngIf="createUserForm.hasError('required', 'abosId')">
            Please enter Abos id
          </mat-error>
        </mat-form-field>
      </div>

</div>

  <div class="modal-footer">
    <button [disabled]="isCreateBtnDisabled" id="createNewUserBtn" mat-raised-button color="primary" type="submit" (click)="create()">
      Create
    </button>
    </div>
</form>
